export default function tocHiddeSubItems() {
	let tocItems = document.querySelectorAll(".ctoc__item");

	tocItems.forEach(item => {
		let parentLi = item.closest("li");
		let nestedOl = parentLi.querySelector("ol");

		if (nestedOl) {
			nestedOl.style.display = "none";
			let chevron = document.createElement("span");
			chevron.classList.add("ctoc__item-icon");
			chevron.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                    <path d="M9 5.30005L6 8.30005L3 5.30005" stroke="#FFE82F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;

			parentLi.insertBefore(chevron, nestedOl);

			chevron.addEventListener("click", function (event) {
				event.stopPropagation();

				if (nestedOl.style.display === "none") {
					nestedOl.style.display = "block";
					chevron.classList.add("ctoc__item-icon--active");
				} else {
					nestedOl.style.display = "none";
					chevron.classList.remove("ctoc__item-icon--active");
				}
			});
		}
	});
}
